<i18n src="@/locales/models/container_planning.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/container_planning_alert.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/package_planning.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/package_planning_alert.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/package_group_planning.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/package_group_planning_alert.yml" lang="yaml"></i18n>

<template>
  <div class="my-8" v-if="container_planning">
    <div class="flex justify-between mt-8 mb-2">
      <h3 class="items-center">
        <div class="panel-header-title">Planificación</div>
      </h3>
    </div>
    <div class="panel">
      <div class="panel-body">
        <div class="space-y-8 divide-y divide-slate-200">
          <div class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
            <div class="sm:col-span-2">
              <dt class="label-data">
                {{ $t("model.container_planning.num_package_groups") }}
              </dt>
              <dd class="content-data">
                {{ container_planning.num_package_groups }}
                <em
                  v-if="container_planning.alert?.package_groups_incocistency"
                  class="text-red-400"
                >
                  {{
                    $t(
                      "model.container_planning_alert.real_num_package_groups",
                      {
                        real_num_package_groups:
                          container_planning.alert.real_num_package_groups,
                      }
                    )
                  }}
                </em>
              </dd>
            </div>

            <div class="sm:col-span-2">
              <dt class="label-data">
                {{ $t("model.container_planning.packages_per_pg") }}
              </dt>
              <dd class="content-data">
                {{ container_planning.packages_per_pg }}
                <em
                  v-if="container_planning.alert?.packages_per_pg_incocistency"
                  class="text-red-400"
                >
                  {{
                    $t("model.container_planning_alert.real_packages_per_pg", {
                      real_packages_per_pg:
                        container_planning.alert.real_packages_per_pg,
                    })
                  }}
                </em>
              </dd>
            </div>

            <div class="sm:col-span-2">
              <dt class="label-data">
                {{ $t("model.container_planning.num_total_packages") }}
              </dt>
              <dd class="content-data">
                {{ container_planning.num_total_packages }}
                <em
                  v-if="container_planning.alert?.total_packages_incocistency"
                  class="text-red-400"
                >
                  {{
                    $t(
                      "model.container_planning_alert.real_num_total_packages",
                      {
                        real_num_total_packages:
                          container_planning.alert.real_num_total_packages,
                      }
                    )
                  }}
                </em>
              </dd>
            </div>
          </div>

          <div
            class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6"
            v-if="container_planning.package_plannings.length > 0"
          >
            <div class="sm:col-span-6">
              <div
                class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6"
                v-for="package_planning in container_planning.package_plannings"
                :key="package_planning.id"
              >
                <div class="sm:col-span-2">
                  <dt class="label-data">
                    {{ $t("model.package_planning.num_packages") }}
                  </dt>
                  <dd class="content-data">
                    {{ package_planning.num_packages }}
                    <em
                      v-if="package_planning.alert?.packages_incocistency"
                      class="text-red-400"
                    >
                      {{
                        $t("model.package_planning_alert.real_num_packages", {
                          real_num_packages:
                            package_planning.alert.real_num_packages,
                        })
                      }}
                    </em>
                  </dd>
                </div>
                <div class="sm:col-span-2">
                  <dt class="label-data">
                    {{ $t("model.package_planning.agro_exporter_brand_id") }}
                  </dt>
                  <dd class="content-data">
                    {{ package_planning.agro_exporter_brand?.name }}
                  </dd>
                </div>
                <div
                  class="sm:col-span-2"
                  v-show="packageCropSizeNames(package_planning)"
                >
                  <dt class="label-data">
                    {{ $t("model.package_planning.size_package_plannings") }}
                  </dt>
                  <dd class="content-data">
                    {{ packageCropSizeNames(package_planning) }}
                  </dd>
                </div>
              </div>
            </div>
          </div>
          <div
            class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6"
            v-if="container_planning.package_group_plannings.length > 0"
          >
            <div class="sm:col-span-6">
              <div
                class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6"
                v-for="package_group_planning in container_planning.package_group_plannings"
                :key="package_group_planning.id"
              >
                <div class="sm:col-span-2">
                  <dt class="label-data">
                    {{ $t("model.package_group_planning.num_package_groups") }}
                  </dt>
                  <dd class="content-data">
                    {{ package_group_planning.num_package_groups }}
                    <em
                      v-if="package_group_planning.alert?.pgs_incocistency"
                      class="text-red-400"
                    >
                      {{
                        $t("model.package_group_planning_alert.real_num_pgs", {
                          real_num_pgs:
                            package_group_planning.alert.real_num_pgs,
                        })
                      }}
                    </em>
                  </dd>
                </div>
                <div class="sm:col-span-2">
                  <dt class="label-data">
                    {{
                      $t("model.package_group_planning.agro_exporter_brand_id")
                    }}
                  </dt>
                  <dd class="content-data">
                    {{ package_group_planning.agro_exporter_brand?.name }}
                  </dd>
                </div>
                <div
                  class="sm:col-span-2"
                  v-show="pgCropSizeNames(package_group_planning)"
                >
                  <dt class="label-data">
                    {{ $t("model.package_group_planning.size_pg_plannings") }}
                  </dt>
                  <dd class="content-data">
                    {{ pgCropSizeNames(package_group_planning) }}
                  </dd>
                </div>
              </div>
            </div>
          </div>

          <div
            class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6"
            v-if="container_planning?.observations"
          >
            <div class="sm:col-span-6">
              <dt class="label-data">
                {{ $t("model.container_planning.observations") }}
              </dt>
              <dd class="content-data">
                {{ container_planning.observations }}
              </dd>
            </div>
          </div>
        </div>
      </div>
      <div class="panel-footer">
        <div class="panel-footer-actions">
          <edit-button @click.prevent="goToEditPlanning()" label="Planificar" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    container_planning: { required: true },
    agro_exporter_process_id: { required: true },
    container_id: { required: true },
  },
  data() {
    return {};
  },
  methods: {
    goToEditPlanning: function () {
      this.$router.push({
        name: "ae_production_basic_container_export_edit_planning_path",
        params: {
          agro_exporter_process_id: this.agro_exporter_process_id,
          container_id: this.container_id,
        },
      });
    },
    packageCropSizeNames: function (package_planning) {
      return package_planning.size_package_plannings
        ?.map((size_planning) => size_planning.crop_size.name)
        ?.join(", ");
    },
    pgCropSizeNames: function (package_group_planning) {
      return package_group_planning.size_pg_plannings
        ?.map((size_planning) => size_planning.crop_size.name)
        ?.join(", ");
    },
  },
};
</script>